import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Tooltip from '@app/src/common/components/tooltip/Tooltip';
import useTranslate from '@app/src/common/hooks/useTranslation';

export interface IProps {
  route?: any;
  className?: string;
  location?: any;
  labelId: string;
  Icon: () => ReactElement;
  collapsed?: boolean;
}

const NavigationItem = ({
  location,
  route,
  className,
  labelId,
  Icon,
  collapsed
}: IProps) => {
  const translate = useTranslate();
  const isActive = () => location && location.pathname.startsWith(route.path);
  const tooltipId = `nav-tooltip-${route.path}`;
  const tooltipLabel = collapsed ? translate(labelId) : '';

  return (
    <>
      <NavLink
        to={route.path}
        className={className}
        activeClassName="navigation__link_active"
        isActive={isActive}
        data-tooltip-id={collapsed ? tooltipId : undefined}
      >
        <div className="navigation__link-inner">
          <span className="navigation__link-icon">
            <Icon />
          </span>
          <FormattedMessage id={labelId}>
            {(...message) => (
              <span className="navigation__link-title">{message}</span>
            )}
          </FormattedMessage>
        </div>
      </NavLink>
      {collapsed && (
        <Tooltip id={tooltipId} place="right" className="navigation__tooltip">
          {tooltipLabel}
        </Tooltip>
      )}
    </>
  );
};

export default NavigationItem;
